import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { VIP_DISCORD_TICKET_URL } from "./vipInvoiceExport";

function DiscordGlyph({ className }) {
    return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
            <path d="M20.317 4.369a19.8 19.8 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.74 19.74 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.056a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.105a13.1 13.1 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 0 1 .077-.01c3.927 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .078.009c.12.099.246.198.373.292a.077.077 0 0 1-.006.127a12.3 12.3 0 0 1-1.873.893a.077.077 0 0 0-.041.105c.36.699.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.84 19.84 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.055c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028Zm-12.5 10.955c-1.183 0-2.157-1.086-2.157-2.42c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.095 2.157 2.42c0 1.333-.956 2.419-2.157 2.419Zm7.975 0c-1.183 0-2.157-1.086-2.157-2.42c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.095 2.157 2.42c0 1.333-.946 2.419-2.157 2.419Z" />
        </svg>
    );
}

export default function VipDiscordTicketButton({ className = "", highlight = false }) {
    const { t } = useI18n();
    return (
        <a
            href={VIP_DISCORD_TICKET_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`vip-sim-discord-btn ${highlight ? "vip-sim-discord-btn--pulse" : ""} ${className}`.trim()}
            aria-label={t("simulator.discord.aria")}
        >
            <span className="vip-sim-discord-btn__glow" aria-hidden />
            <span className="vip-sim-discord-btn__inner">
                <span className="vip-sim-discord-btn__icon-wrap">
                    <DiscordGlyph className="vip-sim-discord-btn__icon" />
                </span>
                <span className="vip-sim-discord-btn__text">
                    <span className="vip-sim-discord-btn__label">{t("simulator.discord.label")}</span>
                    <span className="vip-sim-discord-btn__sub">{t("simulator.discord.sub")}</span>
                </span>
                <span className="vip-sim-discord-btn__arrow" aria-hidden>
                    →
                </span>
            </span>
        </a>
    );
}
